import {
    Header,
    HeroSection,
    FeatureSection,
    PricingSection,
    TestimonialSection,
    FaqSection,
    ContactSection,
    Footer,
} from "../components/sections";

import { header, faqs, testimonials, features, pricing, footer } from "../data";

function Qease() {
    return (
        <main className="flex flex-col font-body text-base-600 dark:text-base-500 bg-base-50 dark:bg-base-950">
            <Header
                logo={header.logo}
                links={header.links}
                buttons={header.buttons}
            />
            <HeroSection
                id="home"
                badge={{
                    leading: true,
                    label: "✦  Solusi Antrian Modern untuk Klinik",
                }}
                title="Kelola Antrian Klinik dengan Mudah"
                description="Qease membantu klinik mengatur proses pendaftaran dan antrian pasien dengan lebih rapi, efisien, dan mudah dipantau."
                buttons={[
                    {
                        href: "#demo",
                        label: "Lihat Video Demo",
                        icon: "tabler:player-play-filled",
                        leading: true,
                        color: "dark",
                    },
                ]}
                image={{
                    src: "./qease-ipad-mockup.svg",
                    alt: "Product Screenshot on Tablet",
                    className: "w-full h-auto drop-shadow-2xl",
                }}
            />
            <FeatureSection
                id="features"
                title="Jelajahi Fitur-fitur Kami"
                description="Semua fitur yang kamu butuhkan untuk mengatur antrian klinik dengan mudah dan real-time."
                features={features}
                badge={{
                    leading: true,
                    label: "Fitur",
                }}
            />
            <PricingSection
                id="pricing"
                title="Paket Berlangganan"
                description="Pilih paket yang paling sesuai dengan kebutuhan Anda dan tingkatkan kapan saja seiring pertumbuhan."
                badge={{
                    leading: true,
                    label: "Paket",
                }}
                pricing={pricing}
            />
            <TestimonialSection
                id="testimonials"
                title="Apa Kata Mereka Tentang Kami"
                description="Dengarkan cerita dari para pengguna kami. Kami terus berkembang berkat masukan dari mereka."
                badge={{
                    leading: true,
                    label: "Testimoni",
                }}
                testimonials={testimonials}
            />
            <FaqSection
                id="faqs"
                title="Tentang Sistem Antrian Kami"
                description="Berikut beberapa pertanyaan yang sering ditanyakan seputar penggunaan dan fitur sistem antrian klinik Qease."
                buttons={[
                    {
                        label: "Hubungi Tim Support",
                        href: "#",
                        color: "primary",
                        variant: "link",
                        className: "text-[#06B6D4]",
                        icon: "tabler:arrow-right",
                    },
                ]}
                faqs={faqs}
            />
            <ContactSection id="contact" />
            <Footer
                id="footer"
                copyright={footer.copyright}
                logo={footer.logo}
                social={footer.social}
                links={footer.links}
            />
        </main>
    );
}

export default Qease;
